var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manufacturer-list-card"},[_c('router-link',{attrs:{"to":_vm.rsi_link}},[_c('div',{staticClass:"row"},[_c('img',{staticClass:"manufacturer-list-image",attrs:{"src":_vm.img_link,"title":_vm.title,"alt":_vm.title}})]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }